import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { formatUsPhone } from "../../../../Hooks/commanUtility";
import Header from "./../../../../Components/Header/Header";
import ReactTable from "./../../../../Components/Table/Table";
import { AppContext } from "./../../../../Context/AppContext";
import { MODULES } from "./../../../../Helpers/Constants";
import { getAccessByModuleName } from "./../../../../Routes/Routes";

import LoadingScreen from "Components/Loading/LoadingScreen";
import { getSystemAccountLookup } from "api/customer";
const SystemAccountLookup = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const navigate = useNavigate();
  const [access, setAccess] = useState({});

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [firstRender, setFirstRender] = useState(true);
  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });

  // Set Async Data
  const setAsyncData = (data) => {
    let asyncDataValuesSystemAccountLookup = JSON.stringify(data);
    localStorage.setItem(
      "asyncDataValuesSystemAccountLookup",
      asyncDataValuesSystemAccountLookup
    );
  };

  // Get And Set Data Into State
  useEffect(() => {
    const filterData = JSON.parse(
      localStorage.getItem("asyncDataValuesSystemAccountLookup")
    );
    if (filterData) {
      const { currentPage, itemsPerPage, globalSearch, filters, sortBy } =
        filterData;
      setDefaultFilter({
        filters: filters,
        pageIndex: currentPage,
        globalFilter: globalSearch,
        pageSize: itemsPerPage,
        sortBy: sortBy,
      });
    }
    setFirstRender(false);
  }, []);

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
  }) => {
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);
    const postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
    };

    const newFilter = filters.filter((x) => x.value.length > 3);

    if (newFilter.length > 0) {
      let accountAccess = getAccessByModuleName(
        modules,
        MODULES.SYSTEM_ACCOUNT_LOOKUP
      );
      if (accountAccess && accountAccess.permissions.read_access) {
        const response = await getSystemAccountLookup(postData);
        if (response && response.status === 200) {
          setData(response.data.data.rows);
          setPageCount(Math.ceil(response.data.data.count / pageSize));
        } else {
          showToastMessage(undefined, response.data.message, "error", false);
        }
      }
    } else {
      setData([]);
      setPageCount(Math.ceil(0 / pageSize));
    }
    setAsyncData(postData);
    setLoading(false);
  };

  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);

  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.SYSTEM_ACCOUNT_LOOKUP);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }

  let accountAccess = getAccessByModuleName(
    modules,
    MODULES.SYSTEM_ACCOUNT_LOOKUP
  );
  const columns = React.useMemo(() => [
    {
      Header: "Customer Name",
      accessor: "customer_name",
      isVisible: true,
      placeholder: "Customer Name",
      Cell: ({ value, row, column }) => {
        return row.original.id === 0 ? (
          <span>
            {`${row.original.customer_name ? row.original.customer_name : "-"}`}
          </span>
        ) : accountAccess && accountAccess.permissions.write_access ? (
          <Link to={`/reports/system-customer/${row.original.id}`}>
            <span className={`cursor-pointer`}>
              {`${
                row.original.customer_name ? row.original.customer_name : "-"
              }`}
            </span>
          </Link>
        ) : (
          <span>
            {`${row.original.customer_name ? row.original.customer_name : "-"}`}
          </span>
        );
      },
    },
    {
      Header: "Phone #",
      accessor: "phone",
      isVisible: true,
      placeholder: "Phone #",
      Cell: ({ value, row, column }) => {
        return `${
          row.original.phone
            ? row.original.country_code +
              " " +
              formatUsPhone(row.original.phone)
            : ""
        }`;
      },
    },
    {
      Header: "Email",
      accessor: "email",
      isVisible: true,
      placeholder: "Email",
      disableFilters: false,
    },
    {
      Header: "Store Location",
      accessor: "store_location",
      isVisible: true,
      placeholder: "Store Location",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ value, row, column }) => {
        return (
          <span>
            {`${
              row.original.order_transactions &&
              row.original.order_transactions.length > 0
                ? row.original.order_transactions[0].store.title
                : "-"
            }`}
          </span>
        );
      },
    },
    {
      Header: "",
      accessor: "id",
      isVisible: true,
      placeholder: "",
      disableFilters: false,
      Cell: ({ value, row, column }) => {
        return <span>{``}</span>;
      },
    },
  ]);

  if (firstRender) return <LoadingScreen />;
  return (
    <React.Fragment>
      <Header title="System Account Lookup" />
      <div id="MainContent" className="main-content">
        {access.read_access && (
          <ReactTable
            columns={columns}
            data={data}
            fetchData={fetchData}
            loading={loading}
            pageCount={pageCount}
            noDataText={"There is no data to display"}
            defaultFilter={defaultFilter}
            displayGlobalSearch={false}
            displayColumnVisibility={false}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default SystemAccountLookup;
